import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "u-text-align-special" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--no-space o-grid__cell--12 o-grid__cell--6-1024 o-grid__cell--offset-4-1024" }
const _hoisted_3 = ["max", "data-fehlermeldung"]
const _hoisted_4 = ["required", "aria-required"]
const _hoisted_5 = {
  for: "gewerbe",
  class: "radiolabel"
}
const _hoisted_6 = { key: 4 }
const _hoisted_7 = ["required", "aria-required"]
const _hoisted_8 = { key: 5 }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_gebaeude_typ = _resolveComponent("gebaeude-typ")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_adresse = _resolveComponent("adresse")!
  const _component_infotext = _resolveComponent("infotext")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_sanierungsfragen = _resolveComponent("sanierungsfragen")!
  const _component_bauartklasse_ermittlung = _resolveComponent("bauartklasse-ermittlung")!
  const _component_gewerbeinformationenMakler = _resolveComponent("gewerbeinformationenMakler")!
  const _component_gewerbeinformationen = _resolveComponent("gewerbeinformationen")!
  const _component_makler_hinweis = _resolveComponent("makler-hinweis")!
  const _component_modal = _resolveComponent("modal")!
  const _component_geschuetzter_router_link = _resolveComponent("geschuetzter-router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      items: _ctx.navItems,
      active: 0,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_ueberschrift, null, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [
          _createTextVNode("Angaben zum Gebäude")
        ])),
        _: 1,
        __: [21]
      }),
      _createVNode(_component_gebaeude_typ, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_adresse, {
        fehler: _ctx.fehler,
        placeholder: true,
        plz: _ctx.piniaStore.state.risikoAnschrift.plz,
        "onUpdate:plz": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.plz) = $event)),
        plzModifiers: { lazy: true },
        ort: _ctx.piniaStore.state.risikoAnschrift.ort,
        "onUpdate:ort": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.ort) = $event)),
        ortModifiers: { lazy: true },
        strasse: _ctx.piniaStore.state.risikoAnschrift.strasse,
        "onUpdate:strasse": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.strasse) = $event)),
        strasseModifiers: { lazy: true },
        hausnummer: _ctx.piniaStore.state.risikoAnschrift.hausnummer,
        "onUpdate:hausnummer": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.hausnummer) = $event)),
        hausnummerModifiers: { lazy: true },
        "zu-pruefen": _ctx.piniaStore.state.risikoAnschrift.zuPruefen,
        "onUpdate:zuPruefen": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.zuPruefen) = $event)),
        feldNamen: {
        plz: 'risikoPostalCode',
        ort: 'risikoCity',
        strasse: 'risikoStreet',
        hausnummer: 'risikoStreetNumber',
      },
        ref: "addresseRef",
        "session-marker": "risikoAnschrift"
      }, {
        plzOrtLabel: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, [
            _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Anschrift", -1)),
            _cache[23] || (_cache[23] = _createTextVNode(" des Gebäudes ")),
            _createElementVNode("span", {
              class: "c-notice-icon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.wechsleSichtbarkeit('infoAnschrift')))
            }, [
              _createVNode(_component_icon_sprite, { "icon-name": "icon-info-i" })
            ])
          ])
        ]),
        strasseHausnummerLabel: _withCtx(() => _cache[24] || (_cache[24] = [
          _createElementVNode("span", { class: "mobil-hidden" }, " ", -1)
        ])),
        _: 1
      }, 8, ["fehler", "plz", "ort", "strasse", "hausnummer", "zu-pruefen"]),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_infotext, {
              name: "infoAnschrift",
              "css-klassen": "o-grid__cell--no-space",
              text: "Diese Angaben werden für die Beitragsberechnung benötigt."
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [
              _createElementVNode("strong", null, "Baujahr", -1),
              _createTextVNode(" des Gebäudes")
            ])),
            _: 1,
            __: [25]
          }),
          _createVNode(_component_zelle, { breite: 3 }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                id: "baujahr",
                name: "baujahr",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.baujahr) = $event)),
                onKeydown: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                class: "c-form-control__input",
                "data-cy": "baujahr",
                min: "1800",
                max: _ctx.naechstesJahr,
                required: "",
                "aria-required": "true",
                "aria-label": "Baujahr des Gebäudes",
                "data-fehlermeldung": _ctx.baujahrFehlerText,
                placeholder: "JJJJ"
              }, null, 40, _hoisted_3), [
                [
                  _vModelText,
                  _ctx.piniaStore.state.gebaeudedaten.baujahr,
                  void 0,
                  {
                    lazy: true,
                    trim: true,
                    number: true
                  }
                ]
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.baujahr
              }, null, 8, ["fehler-text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.piniaStore.state.isMakler)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "denkmalschutz"
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createTextVNode(" Steht das Gebäude unter Denkmalschutz?")
                ])),
                _: 1,
                __: [26]
              }),
              _createVNode(_component_zelle, { class: "mkRadio" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.denkmalschutzManuell) = $event)),
                    type: "radio",
                    id: "nichtDenkmalschutz",
                    name: "denkmalschutz",
                    value: false,
                    "data-cy": "denkmalNo",
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Nein, das Gebäude steht nicht unter Denkmalschutz",
                    "data-fehlermeldung": "Bitte treffen Sie eine Auswahl."
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.denkmalschutzManuell]
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("label", {
                    for: "nichtDenkmalschutz",
                    class: "radiolabel"
                  }, "Nein", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.denkmalschutzManuell) = $event)),
                    type: "radio",
                    id: "denkmalschutz",
                    name: "denkmalschutz",
                    value: true,
                    "aria-label": "Ja, das Gebäude steht unter Denkmalschutz",
                    "data-cy": "denkmalYes"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.denkmalschutzManuell]
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("label", {
                    for: "denkmalschutz",
                    class: "radiolabel"
                  }, "Ja", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.denkmalschutz,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_infotext, {
                    name: "denkmalschutz",
                    "css-klassen": "o-grid__cell--no-space",
                    text: "Sofern das Gebäude unter Denkmalschutz steht, reichen Sie uns bitte den ausgefüllten Denkmalschutzbogen zur Risikoprüfung mit ein. Nach Auswertung des Bogens kann sich der Beitrag ggf. erhöhen."
                  })
                ]),
                _: 1,
                __: [27,28]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.isMakler && _ctx.aelterAls30)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "kernsanierungDurchgefuehrtInfo"
              }, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createTextVNode(" Wurde eine Kernsanierung durchgeführt? ")
                ])),
                _: 1,
                __: [29]
              }),
              _createVNode(_component_zelle, { class: "mkRadio" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt) = $event)),
                    type: "radio",
                    id: "kernsanierungNichtDurchgefuehrt",
                    name: "kernsanierungDurchgefuehrt",
                    value: false,
                    "data-cy": "kernsanierungNein",
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Nein, es wurde keine Kernsanierung durchgeführt",
                    "data-fehlermeldung": "Bitte treffen Sie eine Auswahl."
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt]
                  ]),
                  _cache[30] || (_cache[30] = _createElementVNode("label", {
                    for: "kernsanierungNichtDurchgefuehrt",
                    class: "radiolabel"
                  }, "Nein", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt) = $event)),
                    type: "radio",
                    id: "kernsanierungDurchgefuehrt",
                    name: "kernsanierungDurchgefuehrt",
                    value: true,
                    "aria-label": "Ja, es wurde eine Kernsanierung durchgeführt",
                    "data-cy": "kernsanierungJa"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt]
                  ]),
                  _cache[31] || (_cache[31] = _createElementVNode("label", {
                    for: "kernsanierungDurchgefuehrt",
                    class: "radiolabel"
                  }, "Ja", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.kernsanierungDurchgefuehrt,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_infotext, {
                    name: "kernsanierungDurchgefuehrtInfo",
                    "css-klassen": "o-grid__cell--no-space",
                    text: "Eine Kernsanierung kann nur dann zu Grunde gelegt werden, wenn die Voraussetzungen gemäß A 27.3, VGB 2018 erfüllt sind. <br />\n          Dies sind folgende: <br />\n          Neuinstallation der kompletten Wasserzuleitungs- und Ableitungsrohre sowie die\n          Heizungsanlage innerhalb und außerhalb des Gebäudes. <br />\n          Neuinstallation der Elektroanlage einschließlich ihrer Leitungen. <br />\n          Die Erneuerung der Dacheindeckung einschließlich Lattung sowie das mit dem Dach\n          verbundene Zubehör."
                  })
                ]),
                _: 1,
                __: [30,31]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.isMakler && (_ctx.aelterAls50 || _ctx.kernsanierungDurchgefuehrt))
        ? (_openBlock(), _createBlock(_component_sanierungsfragen, {
            key: 2,
            aelterAls50: _ctx.aelterAls50,
            fehler: _ctx.fehler
          }, null, 8, ["aelterAls50", "fehler"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ueberschrift, null, {
        default: _withCtx(() => _cache[32] || (_cache[32] = [
          _createTextVNode("Angaben zur Bauart")
        ])),
        _: 1,
        __: [32]
      }),
      _createVNode(_component_bauartklasse_ermittlung, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_ueberschrift, null, {
        default: _withCtx(() => _cache[33] || (_cache[33] = [
          _createTextVNode("Angaben zur Nutzung")
        ])),
        _: 1,
        __: [33]
      }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => _cache[34] || (_cache[34] = [
              _createElementVNode("strong", null, "Gebäudenutzung", -1)
            ])),
            _: 1,
            __: [34]
          }),
          _createVNode(_component_zelle, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("select", {
                id: "gebaeudenutzung",
                name: "gebaeudenutzung",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gebaeudenutzung) = $event)),
                class: "c-form-control-select",
                "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                required: "",
                "aria-required": "true",
                "aria-label": "Wie wird das Gebäude genutzt?",
                "data-cy": "Nutzungsart"
              }, _cache[35] || (_cache[35] = [
                _createElementVNode("option", { value: "0001" }, "Ständig bewohnte Immobilie", -1),
                _createElementVNode("option", { value: "0002" }, "Ferien-/Wochenendhaus", -1),
                _createElementVNode("option", { value: "0003" }, "Teilweise leerstehende Immobilie", -1),
                _createElementVNode("option", { value: "0004" }, "Leerstehende Immobilie", -1)
              ]), 512), [
                [_vModelSelect, _ctx.piniaStore.state.gebaeudedaten.gebaeudenutzung]
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.gebaeudenutzung,
                "reduzierter-abstand": true
              }, null, 8, ["fehler-text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.piniaStore.state.gebaeudedaten.gebaeudenutzung === '0003')
        ? (_openBlock(), _createBlock(_component_zeile, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[36] || (_cache[36] = [
                  _createElementVNode("strong", null, "Anteil Leerstand", -1),
                  _createTextVNode(" in %")
                ])),
                _: 1,
                __: [36]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "leerstand",
                    name: "leerstand",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.leerstand) = $event)),
                    class: "c-form-control__input",
                    min: "1",
                    max: "99",
                    required: _ctx.piniaStore.state.gebaeudedaten.gebaeudenutzung === '0003',
                    "aria-required": _ctx.piniaStore.state.gebaeudedaten.gebaeudenutzung === '0003',
                    "aria-label": "Anteil Leerstand in Prozent",
                    "data-fehlermeldung": "Bitte geben Sie den Leerstand zwischen 1 und 99 Prozent an",
                    "data-cy": "LeerstandAnteil"
                  }, null, 40, _hoisted_4), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.leerstand,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.leerstand
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode(" Befindet sich ein "),
              _createElementVNode("strong", null, "Gewerbe", -1),
              _createTextVNode(" im Gebäude")
            ])),
            _: 1,
            __: [37]
          }),
          _createVNode(_component_zelle, { class: "mkRadio" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden) = $event)),
                type: "radio",
                id: "keinGewerbe",
                name: "gewerbe",
                value: false,
                required: "",
                "aria-required": "true",
                "aria-label": "Nein, es befindet sich kein Gewerbe im Gebäude",
                "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                "data-cy": "gewerbeNo"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden]
              ]),
              _cache[38] || (_cache[38] = _createElementVNode("label", {
                for: "keinGewerbe",
                class: "radiolabel"
              }, "Nein", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden) = $event)),
                type: "radio",
                id: "gewerbe",
                name: "gewerbe",
                value: true,
                "aria-label": "Ja, es befindet sich ein Gewerbe im Gebäude",
                "data-cy": "gewerbeYes"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden]
              ]),
              _createElementVNode("label", _hoisted_5, "Ja " + _toDisplayString(_ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden === true ? "(maximal 49% der Gebäudefläche)" : ""), 1),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.gewerbe,
                "reduzierter-abstand": true
              }, null, 8, ["fehler-text"])
            ]),
            _: 1,
            __: [38]
          })
        ]),
        _: 1
      }),
      (_ctx.piniaStore.state.isMakler && _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_zeile, null, {
              default: _withCtx(() => [
                _createVNode(_component_titel_zelle, null, {
                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                    _createTextVNode(" Anzahl der Gewerbe")
                  ])),
                  _: 1,
                  __: [39]
                }),
                _createVNode(_component_zelle, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      id: "gewerbeAnzahl",
                      name: "gewerbeAnzahl",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gewerbeAnzahl) = $event)),
                      class: "c-form-control-select",
                      "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                      required: _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden === true,
                      "aria-required": _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden === true,
                      "aria-label": "Anzahl der Gewerbe im Gebäude",
                      "data-cy": "gewerbeAnzahl"
                    }, _cache[40] || (_cache[40] = [
                      _createElementVNode("option", { value: 1 }, "1", -1),
                      _createElementVNode("option", { value: 2 }, "2", -1),
                      _createElementVNode("option", { value: 3 }, "3", -1),
                      _createElementVNode("option", { value: 4 }, "4", -1)
                    ]), 8, _hoisted_7), [
                      [
                        _vModelSelect,
                        _ctx.piniaStore.state.gebaeudedaten.gewerbeAnzahl,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createVNode(_component_validierungs_fehler, {
                      "fehler-text": _ctx.fehler.gewerbeAnzahl,
                      "reduzierter-abstand": true
                    }, null, 8, ["fehler-text"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.piniaStore.state.gebaeudedaten.gewerbeAnzahl, (gewerbeId) => {
              return (_openBlock(), _createBlock(_component_gewerbeinformationenMakler, {
                key: gewerbeId,
                gewerbeId: gewerbeId,
                fehler: _ctx.fehler
              }, null, 8, ["gewerbeId", "fehler"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.piniaStore.state.isMakler && _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_gewerbeinformationen, {
              gewerbeId: 1,
              fehler: _ctx.fehler
            }, null, 8, ["fehler"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 5,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-1 u-mar-b-2 mobil-mehrAbstand",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                "data-cy": "submitZumVergleich",
                disabled: _ctx.submitDeaktiviert
              }, " Weiter zur Gebäudeausstattung ", 8, _hoisted_9)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.showables.toggleLeerstand)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 6,
            onCloseModal: _ctx.toggleLeerstand,
            titel: "Leerstand"
          }, {
            inhalt: _withCtx(() => [
              _createVNode(_component_makler_hinweis)
            ]),
            _: 1
          }, 8, ["onCloseModal"]))
        : _createCommentVNode("", true),
      (_ctx.showables.toggleFerienhaus)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 7,
            onCloseModal: _ctx.toggleFerienhausCheck,
            titel: "Ferienhaus / Ferienwohnung"
          }, {
            inhalt: _withCtx(() => [
              _cache[42] || (_cache[42] = _createTextVNode(" Unser Ferienhauskonzept passt noch besser zu ihrem Ferienobjekt. ")),
              (!_ctx.piniaStore.state.isMakler)
                ? (_openBlock(), _createBlock(_component_geschuetzter_router_link, {
                    key: 0,
                    to: "/fh"
                  }, {
                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                      _createTextVNode("Hier geht's direkt zum Tarifrechner. ")
                    ])),
                    _: 1,
                    __: [41]
                  }))
                : _createCommentVNode("", true),
              (_ctx.piniaStore.state.isMakler)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "#",
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.maklerWechsel && _ctx.maklerWechsel(...args)))
                  }, " Hier geht's direkt zum Tarifrechner. "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onCloseModal"]))
        : _createCommentVNode("", true),
      (_ctx.showables.toggleDenkmalschutz)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 8,
            onCloseModal: _ctx.toggleDenkmalschutz,
            titel: "Denkmalschutz",
            hatSchliessenButton: true
          }, {
            inhalt: _withCtx(() => _cache[43] || (_cache[43] = [
              _createTextVNode(" Bitte überprüfen Sie die Angabe zum Denkmalschutz.")
            ])),
            _: 1
          }, 8, ["onCloseModal"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}